import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ai-step-circle",
  "use": "icon-ai-step-circle-usage",
  "viewBox": "0 0 7 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 8\" fill=\"none\" id=\"icon-ai-step-circle\">\n  <circle cx=\"3.5\" cy=\"4\" r=\"3.5\" fill=\"#E1E2E6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol